import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ActionRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing('lg')};
`;
